export const images = {
  errorImageIcon: '/assets/error-image.png',
  logo: '/assets/wannit-logo.png',
  kakaotalkImage: '/assets/kakaotalk-logo.png'
};

export const BLUR_URL =
  'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mN8//HLfwYiAOOoQvoqBABbWyZJf74GZgAAAABJRU5ErkJggg==';
